import SubscriptionModel from '../../../models/stripe/Subscription';
import HttpReference from '../../platform/HttpReference';
import Subscriptions from './Subscriptions';

export default class Subscription extends HttpReference<SubscriptionModel, void, Subscriptions> {}
